import * as React from 'react';
import { object as PropObject } from 'prop-types';

import { User, Person, ValidationError } from '../gs-core/common';
import { Search, UserMenuItem } from '../gs-core/client';

import { ActionType, SearchScope, Subject } from '../common/models';
import { ServiceRegistry } from '../services';

interface SubjectSearchProps {
  autoFocus?: boolean;
  className?: string;
  subject?: Subject;
  onSelect: (subject?: Subject) => void;
  clearOnSelect?: boolean;
  action: ActionType;
}

interface SubjectSearchState {
  searchScope?: SearchScope;
  placeholder: string;
}

export class SubjectSearch extends React.Component<SubjectSearchProps, SubjectSearchState> {
  static contextTypes = { services: PropObject };

  private searchComponent: Search<User | Person> | null = null;

  constructor(props: SubjectSearchProps) {
    super(props);
    this.state = { placeholder: '' };
  }

  async componentDidMount() {
    const { subjectService, errorLogger } = this.context.services as ServiceRegistry;

    try {
      const subjectType = this.props.subject && this.props.subject.type;
      const searchScope = await subjectService.findSearchScope(this.props.action, subjectType);
      const placeholder = subjectService.toPlaceholder(searchScope);

      this.setState({ searchScope, placeholder });
    } catch (err) {
      await errorLogger.log(err);
    }
  }

  search = async (searchText: string): Promise<User[]> => {
    const { subjectService, errorLogger } = this.context.services as ServiceRegistry;

    try {
      return subjectService.search(searchText, this.state.searchScope as SearchScope);
    } catch (err) {
      await errorLogger.log(err);
    }

    return [];
  };

  renderDropdownItem = (user: User) => <UserMenuItem user={user}/>;

  select = async (minimalUser: User | undefined) => {
    const { subjectService, errorLogger } = this.context.services as ServiceRegistry;

    try {
      const selection = minimalUser ? await subjectService.findSelection(minimalUser.id as number) : undefined;

      if (minimalUser && !selection) {
        const { placeholder } = this.state;
        throw new ValidationError(`${minimalUser.displayName || minimalUser.name} is not a ${placeholder}`);
      }

      this.props.onSelect(selection && selection.selectedSubject);
    } catch (err) {
      await errorLogger.log(err);
    }
  };

  focus = () => this.searchComponent && this.searchComponent.focus();

  render() {
    return (
      <Search
        autoFocus={this.props.autoFocus || false}
        className={this.props.className}
        load={this.search}
        minLength={3}
        onSelect={this.select}
        clearOnSelect={this.props.clearOnSelect || false}
        placeholder={'Search for ' + this.state.placeholder}
        renderSuggestion={this.renderDropdownItem}
        value={this.props.subject && this.props.subject.user}
        highlightFirst={true}
        ref={(component: Search<User | Person> | null) => this.searchComponent = component}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Subject/SubjectSearch.tsx